(function (window, document) {
    function qs(sel, root) {
        return (root || document).querySelector(sel);
    }

    function qsa(sel, root) {
        return Array.prototype.slice.call((root || document).querySelectorAll(sel));
    }

    function vgPageGutterPx() {
        try {
            if (!document || !document.body) return NaN;
            var el = document.createElement('div');
            el.style.cssText =
                'position:absolute;visibility:hidden;pointer-events:none;left:0;top:0;' +
                'width:0;height:0;padding-left:var(--vg-page-gutter);';
            document.body.appendChild(el);
            var px = parseFloat((window.getComputedStyle(el).paddingLeft || '').replace('px', ''));
            if (el && el.parentNode) el.parentNode.removeChild(el);
            if (isFinite(px) && px > 0) return px;
        } catch (e) {}
        return NaN;
    }

    function vgMapFitPaddingPx() {
        var g = vgPageGutterPx();
        if (!isFinite(g) || g <= 0) g = 56;
        return Math.max(12, Math.min(96, Math.round(g)));
    }

    function buildBaseStyle() {
        return {
            version: 8,
            sources: {
                osm: {
                    type: 'raster',
                    tiles: ['https://tile.openstreetmap.org/{z}/{x}/{y}.png'],
                    tileSize: 256,
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                }
            },
            layers: [{ id: 'osm-tiles', type: 'raster', source: 'osm', minzoom: 0, maxzoom: 19 }]
        };
    }

    function clampMapToEurope(map) {
        if (!map) return;
        var EU = [[-25.0, 30.0], [45.0, 72.0]];
        try {
            if (map.setMaxBounds) map.setMaxBounds(EU);
        } catch (eB) {}
        try {
            if (map.cameraForBounds && map.setMinZoom) {
                var cam = map.cameraForBounds(EU, { padding: vgMapFitPaddingPx() });
                if (cam && isFinite(cam.zoom)) {
                    map.setMinZoom(Math.max(0, cam.zoom - 0.25));
                }
            }
        } catch (eZ) {}
    }

    function fitBoundsFromBBox(map, bboxArr, duration) {
        if (!map || !bboxArr || bboxArr.length < 4) return;
        var minLon = bboxArr[0], minLat = bboxArr[1], maxLon = bboxArr[2], maxLat = bboxArr[3];
        if (!isFinite(minLon) || !isFinite(minLat) || !isFinite(maxLon) || !isFinite(maxLat)) return;
        if (minLon >= maxLon || minLat >= maxLat) return;
        try {
            map.fitBounds([[minLon, minLat], [maxLon, maxLat]], {
                padding: vgMapFitPaddingPx(),
                duration: typeof duration === 'number' ? duration : 550
            });
        } catch (e) {}
    }

    function parseBBox(val) {
        if (!val) return null;
        // MapLibre may coerce properties (arrays -> strings). Support both.
        if (Array.isArray(val) && val.length >= 4) {
            var a0 = Number(val[0]), a1 = Number(val[1]), a2 = Number(val[2]), a3 = Number(val[3]);
            if (isFinite(a0) && isFinite(a1) && isFinite(a2) && isFinite(a3)) return [a0, a1, a2, a3];
        }
        if (typeof val === 'string') {
            // tolerate brackets: "[6.6,36.6,18.9,47.2]"
            val = val.replace(/^\s*\[/, '').replace(/\]\s*$/, '');
            var parts = val.split(',').map(function (s) { return Number(String(s).trim()); });
            if (parts.length >= 4 && isFinite(parts[0]) && isFinite(parts[1]) && isFinite(parts[2]) && isFinite(parts[3])) {
                return [parts[0], parts[1], parts[2], parts[3]];
            }
        }
        return null;
    }

    function bboxFromGeometry(geom) {
        // Return [minLon, minLat, maxLon, maxLat] or null
        if (!geom || !geom.type || !geom.coordinates) return null;
        var minLon = Infinity, minLat = Infinity, maxLon = -Infinity, maxLat = -Infinity;

        function scanCoords(c) {
            if (!c) return;
            if (typeof c[0] === 'number' && typeof c[1] === 'number') {
                var lon = c[0], lat = c[1];
                if (isFinite(lon) && isFinite(lat)) {
                    if (lon < minLon) minLon = lon;
                    if (lat < minLat) minLat = lat;
                    if (lon > maxLon) maxLon = lon;
                    if (lat > maxLat) maxLat = lat;
                }
                return;
            }
            if (Array.isArray(c)) {
                for (var i = 0; i < c.length; i++) scanCoords(c[i]);
            }
        }

        if (geom.type === 'GeometryCollection' && Array.isArray(geom.geometries)) {
            geom.geometries.forEach(function (g) { scanCoords(g && g.coordinates); });
        } else {
            scanCoords(geom.coordinates);
        }

        if (!isFinite(minLon) || !isFinite(minLat) || !isFinite(maxLon) || !isFinite(maxLat)) return null;
        if (minLon >= maxLon || minLat >= maxLat) return null;
        return [minLon, minLat, maxLon, maxLat];
    }

    function italyApproxBbox() {
        // Safe fallback if geojson meta bbox is missing
        return [6.6, 36.6, 18.9, 47.2];
    }

    function normFundingTagSlugFromHref(href) {
        // /tag/funding-piemonte/ or https://.../tag/funding-piemonte/
        href = String(href || '');
        var m = href.match(/\/tag\/(funding-[a-z0-9-]+)\/?/i);
        if (!m) return null;
        return String(m[1]).toLowerCase();
    }

    function normFundingSlugFromText(t) {
        // post-card renders tag names as <span>, not links.
        t = String(t || '').trim().toLowerCase();
        if (!t) return null;
        if (!/^funding-[a-z0-9-]+$/.test(t)) return null;
        return t;
    }

    function extractRegionSlugFromCard(card) {
        var tagLinks = qsa('a[href*="/tag/funding-"]', card);
        var tagSpans = qsa('.post-card-tags .post-card-primary-tag', card);
        var hasNational = false;
        var regionSlug = null;

        tagLinks.forEach(function (a) {
            var slug = normFundingTagSlugFromHref(a.getAttribute('href') || '');
            if (!slug) return;
            if (slug === 'funding-regional') return;
            if (slug === 'funding-national') {
                hasNational = true;
                return;
            }
            // regional region tag (funding-piemonte, etc.)
            if (!regionSlug) regionSlug = slug.replace(/^funding-/, '');
        });

        tagSpans.forEach(function (s) {
            var slug = normFundingSlugFromText(s.textContent || '');
            if (!slug) return;
            if (slug === 'funding-regional') return;
            if (slug === 'funding-national') {
                hasNational = true;
                return;
            }
            if (!regionSlug) regionSlug = slug.replace(/^funding-/, '');
        });

        if (regionSlug) return regionSlug;
        if (hasNational) return '__national__';
        return null;
    }

    function initFundingPostIndex(root) {
        var feed = qs('[data-vg-funding-post-feed]', root || document) || qs('.post-feed', root || document);
        var cards = feed ? qsa('.post-card', feed) : [];
        var regionSet = {};
        var nationalCount = 0;
        var originalHtml = feed ? String(feed.innerHTML || '') : '';

        cards.forEach(function (card) {
            var slug = extractRegionSlugFromCard(card);
            if (!slug) return;
            card.setAttribute('data-vg-region-slug', slug);
            if (slug === '__national__') {
                nationalCount += 1;
                return;
            }
            regionSet[slug] = true;
        });

        return { feed: feed, cards: cards, activeRegions: regionSet, nationalCount: nationalCount, originalHtml: originalHtml };
    }

    function applyPostFilter(index, slug, label) {
        if (!index || !index.feed) return;
        var selection = qs('[data-vg-funding-selection]');
        var labelEl = qs('[data-vg-funding-selection-label]', selection);
        var resetBtn = qs('[data-vg-funding-reset]', selection);

        var isReset = !slug;
        if (isReset) {
            // If we replaced the feed via remote tag fetch, restore original HTML first.
            try {
                if (index && index.feed && typeof index.originalHtml === 'string') {
                    if (index.feed.getAttribute('data-vg-feed-replaced') === '1') {
                        index.feed.innerHTML = index.originalHtml;
                        index.feed.removeAttribute('data-vg-feed-replaced');
                        // Rebuild index cards/regions for proper filtering
                        var rebuilt = initFundingPostIndex(document);
                        index.cards = rebuilt.cards;
                        index.activeRegions = rebuilt.activeRegions;
                        index.nationalCount = rebuilt.nationalCount;
                    }
                }
            } catch (eR) {}
            index.cards.forEach(function (card) {
                card.removeAttribute('data-vg-hidden');
            });
            if (selection) selection.hidden = true;
            if (index.feed) index.feed.classList.remove('is-filtered');
            return;
        }

        index.cards.forEach(function (card) {
            var s = card.getAttribute('data-vg-region-slug') || '';
            if (s !== slug) card.setAttribute('data-vg-hidden', '1');
            else card.removeAttribute('data-vg-hidden');
        });
        if (index.feed) index.feed.classList.add('is-filtered');
        if (selection) {
            selection.hidden = false;
            if (labelEl) labelEl.textContent = String(label || '');
            if (resetBtn) resetBtn.focus({ preventScroll: true });
        }
    }

    function hasCardsForRegion(index, slug) {
        if (!index || !index.cards || !index.cards.length) return false;
        slug = String(slug || '');
        if (!slug) return false;
        for (var i = 0; i < index.cards.length; i++) {
            var s = index.cards[i].getAttribute('data-vg-region-slug') || '';
            if (s === slug) return true;
        }
        return false;
    }

    function extractCardsHtmlFromTagPage(html) {
        html = String(html || '');
        if (!html) return null;
        try {
            var doc = (new window.DOMParser()).parseFromString(html, 'text/html');
            if (!doc) return null;
            var feed = qs('[data-vg-funding-post-feed]', doc) || qs('.post-feed', doc);
            if (!feed) return null;
            // Keep only card markup; ignore scripts/styles from remote page.
            var cards = qsa('.post-card', feed);
            if (!cards || !cards.length) return null;
            return cards.map(function (c) { return c.outerHTML; }).join('');
        } catch (e) {}
        return null;
    }

    function loadRegionPostsIntoFeed(index, slug) {
        if (!index || !index.feed) return Promise.resolve(false);
        slug = String(slug || '').toLowerCase();
        if (!slug) return Promise.resolve(false);
        var url = '/tag/funding-' + encodeURIComponent(slug) + '/';
        return fetch(url, { credentials: 'same-origin' })
            .then(function (r) { return r && r.ok ? r.text() : ''; })
            .then(function (html) {
                var cardsHtml = extractCardsHtmlFromTagPage(html);
                if (!cardsHtml) return false;
                try {
                    index.feed.innerHTML = cardsHtml;
                    index.feed.setAttribute('data-vg-feed-replaced', '1');
                    var rebuilt = initFundingPostIndex(document);
                    index.cards = rebuilt.cards;
                    index.activeRegions = rebuilt.activeRegions;
                    index.nationalCount = rebuilt.nationalCount;
                } catch (eI) {}
                return true;
            })
            .catch(function () { return false; });
    }

    function ensureResetHook(index, map, italyBBox) {
        var resetBtn = qs('[data-vg-funding-reset]');
        if (!resetBtn) return;
        resetBtn.addEventListener('click', function () {
            applyPostFilter(index, null, '');
            fitBoundsFromBBox(map, italyBBox || italyApproxBbox(), 650);
        });
    }

    function addNationalPin(map, index, italyBBox) {
        if (!window.maplibregl || !map || !index) return;
        if (!index.nationalCount) return;

        var el = document.createElement('button');
        el.type = 'button';
        el.className = 'vg-funding-pin';
        el.setAttribute('data-vg-funding-national', '1');
        el.setAttribute('aria-label', 'Mostra i finanziamenti nazionali');
        el.innerHTML =
            '<span class="vg-funding-pin__icon" aria-hidden="true">IT</span>' +
            '<span class="vg-funding-pin__label">Nazionali</span>' +
            '<span class="vg-funding-pin__count" data-vg-national-count></span>';

        var countEl = qs('[data-vg-national-count]', el);
        if (countEl) countEl.textContent = String(index.nationalCount);

        el.addEventListener('click', function () {
            applyPostFilter(index, '__national__', 'Italia (nazionali)');
            // National stays on Italy view
            fitBoundsFromBBox(map, italyBBox || italyApproxBbox(), 650);
        });

        // Mar Tirreno
        var marker = new window.maplibregl.Marker({ element: el, anchor: 'bottom' })
            .setLngLat([12.5, 40.5])
            .addTo(map);

        return marker;
    }

    function safeJsonParse(v) {
        try { return JSON.parse(v); } catch (e) { return null; }
    }

    function fundingActiveRegionsCacheKey() {
        return 'vg_funding_active_regions_v1';
    }

    // -- Selected region persistence ---------------------------------------------------
    // Persisted across page loads so the user lands on the funding map with the same
    // region pre-selected (mirrors how `vg-section` keeps the Appalti/Finanziamenti tab).
    var FUNDING_REGION_KEY = 'vg-funding-region';

    function readSelectedFundingRegion() {
        try {
            if (!window.localStorage) return null;
            var raw = window.localStorage.getItem(FUNDING_REGION_KEY);
            if (!raw) return null;
            var obj = safeJsonParse(raw);
            if (!obj || typeof obj.slug !== 'string') return null;
            var slug = obj.slug.toLowerCase();
            if (!slug) return null;
            return { slug: slug, label: String(obj.label || slug) };
        } catch (e) {}
        return null;
    }

    function writeSelectedFundingRegion(slug, label) {
        try {
            if (!window.localStorage) return;
            if (!slug) {
                window.localStorage.removeItem(FUNDING_REGION_KEY);
                return;
            }
            window.localStorage.setItem(
                FUNDING_REGION_KEY,
                JSON.stringify({ slug: String(slug).toLowerCase(), label: String(label || ''), t: Date.now() })
            );
        } catch (e) {}
    }

    function clearSelectedFundingRegion() {
        try { if (window.localStorage) window.localStorage.removeItem(FUNDING_REGION_KEY); } catch (e) {}
    }

    function getFundingMemberUuid() {
        try {
            var el = document.querySelector('[data-member-uuid]');
            if (el) {
                var v = (el.getAttribute('data-member-uuid') || '').trim();
                if (v) return v;
            }
            var meta = document.querySelector('meta[name="vg-member-uuid"]');
            if (meta) {
                var mv = (meta.getAttribute('content') || '').trim();
                if (mv) return mv;
            }
        } catch (e) {}
        return '';
    }

    var _fundingSyncTimer = null;
    function syncFundingRegionToServer(slug, label) {
        var uuid = getFundingMemberUuid();
        if (!uuid) return;
        try { if (_fundingSyncTimer) clearTimeout(_fundingSyncTimer); } catch (e) {}
        _fundingSyncTimer = window.setTimeout(function () {
            try {
                fetch('/api/telegram/funding-settings', {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        member_uuid: uuid,
                        partial: true,
                        selected_region: slug ? { slug: String(slug).toLowerCase(), label: String(label || '') } : null
                    })
                }).catch(function () {});
            } catch (e) {}
        }, 300);
    }

    function loadActiveRegionsFromCache(maxAgeMs) {
        try {
            if (!window.sessionStorage) return null;
            var raw = window.sessionStorage.getItem(fundingActiveRegionsCacheKey());
            if (!raw) return null;
            var obj = safeJsonParse(raw);
            if (!obj || !obj.t || !obj.regions) return null;
            if (typeof obj.t !== 'number') return null;
            if ((Date.now() - obj.t) > (typeof maxAgeMs === 'number' ? maxAgeMs : 10 * 60 * 1000)) return null;
            return obj.regions;
        } catch (e) {}
        return null;
    }

    function saveActiveRegionsToCache(regionSet) {
        try {
            if (!window.sessionStorage) return;
            var regions = {};
            Object.keys(regionSet || {}).forEach(function (k) { regions[String(k)] = true; });
            window.sessionStorage.setItem(fundingActiveRegionsCacheKey(), JSON.stringify({ t: Date.now(), regions: regions }));
        } catch (e) {}
    }

    function fetchRegionActiveByTagPage(slug) {
        // Determine if a region is active by checking the tag page, which is independent from pagination
        // on /finanziamenti-e-incentivi/.
        slug = String(slug || '').toLowerCase();
        if (!slug) return Promise.resolve(false);
        var url = '/tag/funding-' + encodeURIComponent(slug) + '/';
        return fetch(url, { credentials: 'same-origin' })
            .then(function (r) { return r && r.ok ? r.text() : ''; })
            .then(function (html) {
                if (!html) return false;
                // If there is at least one post-card on the tag page, the region is active.
                return /class=["'][^"']*post-card\b/i.test(html);
            })
            .catch(function () { return false; });
    }

    function computeActiveRegionsFromTagPages(features, knownActive) {
        var base = {};
        Object.keys(knownActive || {}).forEach(function (k) { base[String(k).toLowerCase()] = true; });

        // cache to avoid 20+ requests every navigation
        var cached = loadActiveRegionsFromCache(30 * 60 * 1000);
        if (cached) {
            Object.keys(cached).forEach(function (k) { base[String(k).toLowerCase()] = true; });
            return Promise.resolve(base);
        }

        var slugs = [];
        (features || []).forEach(function (f) {
            var props = (f && f.properties) ? f.properties : null;
            var s = props ? String(props.slug || '').toLowerCase() : '';
            if (s) slugs.push(s);
        });

        // limit concurrency a bit (friendly to origin)
        var maxInFlight = 4;
        var i = 0;
        var inFlight = 0;
        var done = 0;
        return new Promise(function (resolve) {
            function pump() {
                while (inFlight < maxInFlight && i < slugs.length) {
                    (function (slug) {
                        inFlight += 1;
                        fetchRegionActiveByTagPage(slug).then(function (isActive) {
                            if (isActive) base[slug] = true;
                        }).finally(function () {
                            inFlight -= 1;
                            done += 1;
                            if (done >= slugs.length) {
                                saveActiveRegionsToCache(base);
                                resolve(base);
                            } else {
                                pump();
                            }
                        });
                    })(slugs[i]);
                    i += 1;
                }
                if (slugs.length === 0) resolve(base);
            }
            pump();
        });
    }

    function initFundingMap() {
        var mapEl = qs('#vg-funding-map');
        if (!mapEl) return;
        if (!window.maplibregl) return;

        var index = initFundingPostIndex(document);
        var geojsonUrl = mapEl.getAttribute('data-geojson-url') || '';
        if (!geojsonUrl) return;

        var map = new window.maplibregl.Map({
            container: mapEl.id || mapEl,
            style: buildBaseStyle(),
            center: [12.5, 42.5],
            zoom: 5.9
        });

        map.addControl(new window.maplibregl.NavigationControl({ visualizePitch: false }), 'top-right');

        map.once('load', function () {
            clampMapToEurope(map);

            fetch(geojsonUrl, { credentials: 'same-origin' })
                .then(function (r) {
                    if (!r.ok) return r.text().then(function (t) { throw new Error('GeoJSON HTTP ' + r.status + (t ? ' ' + t.slice(0, 120) : '')); });
                    return r.json();
                })
                .then(function (fc) {
                    if (!fc || !Array.isArray(fc.features)) throw new Error('GeoJSON invalido');

                    var italyBBox = (fc && fc.meta && Array.isArray(fc.meta.bbox_italy)) ? fc.meta.bbox_italy : null;

                    var _pendingRestore = readSelectedFundingRegion();
                    computeActiveRegionsFromTagPages(fc.features, index.activeRegions).then(function (activeSet) {
                        try { index.activeRegions = activeSet || {}; } catch (eS) {}
                        fc.features.forEach(function (f) {
                            var props = (f && f.properties) ? f.properties : null;
                            if (!props) return;
                            var slug = String(props.slug || '').toLowerCase();
                            props.active = !!(slug && activeSet && activeSet[slug]);
                        });
                        try { map.getSource('vg-funding-regions').setData(fc); } catch (eU) {}
                        if (_pendingRestore && _pendingRestore.slug && activeSet && activeSet[_pendingRestore.slug]) {
                            window.setTimeout(function () { restoreSelection(_pendingRestore, fc); }, 0);
                        }
                    });

                    var sourceId = 'vg-funding-regions';
                    var fillId = 'vg-funding-regions-fill';
                    var lineId = 'vg-funding-regions-line';
                    var selectedId = 'vg-funding-regions-selected';

                    map.addSource(sourceId, { type: 'geojson', data: fc });

                    map.addLayer({
                        id: fillId,
                        type: 'fill',
                        source: sourceId,
                        paint: {
                            'fill-color': [
                                'case',
                                ['boolean', ['get', 'active'], false],
                                '#2563eb',
                                '#94a3b8'
                            ],
                            'fill-opacity': [
                                'case',
                                ['boolean', ['get', 'active'], false],
                                0.35,
                                0.14
                            ]
                        }
                    });

                    // Selected region overlay (red, transparent)
                    map.addLayer({
                        id: selectedId,
                        type: 'fill',
                        source: sourceId,
                        paint: {
                            'fill-color': '#ef4444',
                            'fill-opacity': 0.22
                        },
                        filter: ['==', ['get', 'slug'], '']
                    });

                    // Use ghost accent color if available (CSS var) by updating paint at runtime
                    try {
                        var accent = (window.getComputedStyle(document.documentElement).getPropertyValue('--ghost-accent-color') || '').trim();
                        if (accent) {
                            map.setPaintProperty(fillId, 'fill-color', [
                                'case',
                                ['boolean', ['get', 'active'], false],
                                accent,
                                '#94a3b8'
                            ]);
                        }
                    } catch (eA) {}

                    map.addLayer({
                        id: lineId,
                        type: 'line',
                        source: sourceId,
                        paint: {
                            'line-color': '#334155',
                            'line-width': 1.2,
                            'line-opacity': 0.65
                        }
                    });

                    fitBoundsFromBBox(map, italyBBox || italyApproxBbox(), 650);

                    // selection bar reset
                    ensureResetHook(index, map, italyBBox);

                    // national pin
                    addNationalPin(map, index, italyBBox);

                    function setSelectedRegionSlug(slug, label) {
                        slug = String(slug || '').toLowerCase();
                        try {
                            if (!slug || slug === '__national__') {
                                map.setFilter(selectedId, ['==', ['get', 'slug'], '']);
                            } else {
                                map.setFilter(selectedId, ['==', ['get', 'slug'], slug]);
                            }
                        } catch (eF) {}
                        if (!slug || slug === '__national__') {
                            clearSelectedFundingRegion();
                            syncFundingRegionToServer(null, null);
                        } else {
                            writeSelectedFundingRegion(slug, label || slug);
                            syncFundingRegionToServer(slug, label || slug);
                        }
                    }

                    try {
                        var resetBtn = qs('[data-vg-funding-reset]');
                        if (resetBtn) resetBtn.addEventListener('click', function () { setSelectedRegionSlug(''); });
                    } catch (eR) {}
                    try {
                        var natBtn = qs('[data-vg-funding-national]');
                        if (natBtn) natBtn.addEventListener('click', function () { setSelectedRegionSlug('__national__'); });
                    } catch (eN) {}

                    function findFeatureBySlug(fc, slug) {
                        if (!fc || !Array.isArray(fc.features)) return null;
                        slug = String(slug || '').toLowerCase();
                        for (var i = 0; i < fc.features.length; i++) {
                            var f = fc.features[i];
                            var p = f && f.properties ? f.properties : null;
                            if (p && String(p.slug || '').toLowerCase() === slug) return f;
                        }
                        return null;
                    }

                    function restoreSelection(restore, fc) {
                        if (!restore || !restore.slug) return;
                        var feat = findFeatureBySlug(fc, restore.slug);
                        var props = feat && feat.properties ? feat.properties : null;
                        var label = restore.label || (props && props.label) || restore.slug;
                        var afterLoaded = function () {
                            applyPostFilter(index, restore.slug, label);
                            setSelectedRegionSlug(restore.slug, label);
                            var bb = props ? parseBBox(props.bbox) : null;
                            if (!bb && feat && feat.geometry) bb = bboxFromGeometry(feat.geometry);
                            if (bb) fitBoundsFromBBox(map, bb, 650);
                        };
                        if (!hasCardsForRegion(index, restore.slug)) {
                            loadRegionPostsIntoFeed(index, restore.slug).finally(afterLoaded);
                        } else {
                            afterLoaded();
                        }
                    }

                    function clickRegion(e) {
                        if (!e || !e.features || !e.features.length) return;
                        var f = e.features[0];
                        var props = f && f.properties ? f.properties : null;
                        var slug = String(props.slug || '').toLowerCase();
                        var label = String(props.label || slug);
                        var isActive = !!(props && props.active);
                        if (!isActive) {
                            // Fallback for early clicks before async activeSet finishes.
                            isActive = !!(slug && index.activeRegions && index.activeRegions[slug]);
                        }
                        if (!isActive) return;
                        var afterLoaded = function () {
                            applyPostFilter(index, slug, label);
                            setSelectedRegionSlug(slug, label);
                            var bb = props ? parseBBox(props.bbox) : null;
                            if (!bb && f && f.geometry) bb = bboxFromGeometry(f.geometry);
                            if (bb) {
                                fitBoundsFromBBox(map, bb, 650);
                            } else {
                                fitBoundsFromBBox(map, italyBBox || italyApproxBbox(), 650);
                            }
                        };

                        // If the current feed doesn't include the region posts (pagination/limit),
                        // fetch the tag page and replace the feed, then filter.
                        if (!hasCardsForRegion(index, slug)) {
                            loadRegionPostsIntoFeed(index, slug).finally(afterLoaded);
                        } else {
                            afterLoaded();
                        }
                    }

                    map.on('click', fillId, clickRegion);

                    map.on('mousemove', fillId, function (e) {
                        try {
                            var f = e && e.features && e.features[0];
                            var props = f && f.properties ? f.properties : null;
                            var slug = props ? String(props.slug || '').toLowerCase() : '';
                            var isActive = !!(props && props.active);
                            if (!isActive) isActive = !!(slug && index.activeRegions && index.activeRegions[slug]);
                            map.getCanvas().style.cursor = isActive ? 'pointer' : '';
                        } catch (eC) {}
                    });
                    map.on('mouseleave', fillId, function () {
                        try { map.getCanvas().style.cursor = ''; } catch (eL) {}
                    });
                })
                .catch(function (err) {
                    try { console.error('[funding-map]', err); } catch (e) {}
                });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFundingMap);
    } else {
        initFundingMap();
    }
})(window, document);

